import script from "./DeleteEventConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteEventConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./DeleteEventConfirmation.vue?vue&type=style&index=0&id=c3f61ac8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3f61ac8"]])

export default __exports__